module.exports = [
  function() {
    return {
      RCL_HANDLE_NA: 0, // 不支持召回
      RCL_HANDLE_DEFFER: 1, // 稍后执行
      RCL_HANDLE_OK: 2, // 召回成功
      RCL_HANDLE_DUPLICATE: 3, // 召回成功 (重复调用)
      RCL_HANDLE_MSG_NOTFOUND: 4, // 召回失败 - 该邮件可能被收件人删除
      RCL_HANDLE_MSG_READ: 5, // 召回失败 - 该邮件已被读取
      RCL_HANDLE_MSG_POPPED: 6, // 召回失败 - 该邮件已被客户端收取（pop3）
      RCL_HANDLE_MSG_PUSHED: 7, // 召回失败 - 该邮件已被客户端收取（push）
      RCL_HANDLE_MSG_EXPIRED: 8, // 召回失败 - 操作已过期
      RCL_HANDLE_MSG_REJECTED: 9, // 召回失败 - 暂不支持召回发往该域名的邮件
      RCL_HANDLE_USR_NOTFOUND: 14, // 召回失败 - 用户不存在
      RCL_HANDLE_ERROR: 15, // 召回失败 - 其它错误
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/read/recallResultType.js